import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchProjects } from "./project.actions";
import type {
  FetchProjectsResponse,
  Projects,
} from "features/project/project.types";

const initialState: Projects = {
  data: [],
  isLoading: false,
  error: null,
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProjects.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(
      fetchProjects.fulfilled,
      (state, action: PayloadAction<FetchProjectsResponse>) => {
        state.data = action.payload;
        state.isLoading = false;
        state.error = null;
      }
    );
    builder.addCase(fetchProjects.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const projectReducer = projectSlice.reducer;
